export const currentPath = (currentRoute) => {
  const paths = currentRoute.matched
  return paths[paths.length - 1].path
}

export const fullPath = (currentRoute, navList) => {
  const currentNav = navList.find(nav => nav.url === currentPath(currentRoute))
  return pathArray([currentNav], navList)
}

export const pathArray = (paths, navList) => {
  if (paths[0].type === 'SYSTEM') {
    return paths
  } else {
    const parentNav = navList.find(nav => nav.id === paths[0].parentId)
    return pathArray([parentNav, ...paths], navList)
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home/nav.js